let styles = {
	'primary-color': "#75FFF1",
	'primary-color-rgb': "117,255,241",
	'primary-button-bg-color': "#203133",
	'secondary-button-bg-color': "#24282F",
	'light-bg-color': "#24282F",
	'dark-bg-color': "#0D0F12",
	'dark-bg-color-rgb': "13,15,18",
	'selection-color': "#2cc786",
	'selection-color-rgb': "44,199,134",
	'text-color': "#A9B2C0",
};



let GlobalStyles = Object.entries(styles)
	.map(([key, value]) => `--${key}:${value}`)
	.join(';');

export default GlobalStyles